import { useEffect } from 'react'
import { useReviewStore } from '@/stores/review-store'

/**
 * Loads and returns the caller's review-tab capabilities for a given
 * (bid, artifact, section?) scope. Result is cached in review-store
 * until a new (bid, artifact, section) triple is passed.
 */
export function useReviewPermissions(
  bidId: string | null,
  artifactId: string | null,
  sectionKey?: string | null,
) {
  const { permissions, permissionsLoading, loadPermissions } = useReviewStore()

  useEffect(() => {
    if (!bidId || !artifactId) return
    void loadPermissions(bidId, artifactId, sectionKey ?? null)
  }, [bidId, artifactId, sectionKey, loadPermissions])

  return {
    permissions,
    isLoading: permissionsLoading,
    canArtifactScope: permissions?.canArtifactScope ?? false,
    canSectionScope: permissions?.canSectionScope ?? false,
    canFixAll: permissions?.canFixAll ?? false,
    fixableSections: new Set(permissions?.fixableSections ?? []),
    canFixSection: (sectionId: string) =>
      permissions?.canFixAll === true ||
      (permissions?.fixableSections ?? []).includes(sectionId),
  }
}
